import React from 'react';
import { Mail, Plus, Trash2 } from 'lucide-react';

const renderEmailList = (loading, emails, onRemoveEmail) => {
  if (loading) {
    return (
      <div className="flex justify-center py-8">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#156ACA]"></div>
      </div>
    );
  }
  if (emails.length === 0) {
    return (
      <div className="text-center py-12 bg-gray-50 rounded-lg border-2 border-dashed border-gray-300">
        <Mail className="h-12 w-12 text-gray-400 mx-auto mb-3" />
        <p className="text-gray-600">No email recipients configured</p>
        <p className="text-sm text-gray-500 mt-1">Add emails to receive daily reports</p>
      </div>
    );
  }
  return (
    <div className="space-y-2">
      {emails.map((email) => (
        <div key={email} className="flex items-center justify-between p-4 bg-gray-50 rounded-lg border border-gray-200" data-testid={`email-row-${email}`}>
          <div className="flex items-center">
            <Mail className="h-5 w-5 text-[#156ACA] mr-3" />
            <span className="text-gray-800">{email}</span>
          </div>
          <button onClick={() => onRemoveEmail(email)} className="text-red-600 hover:text-red-800 p-2" data-testid={`remove-email-${email}`}>
            <Trash2 className="h-5 w-5" />
          </button>
        </div>
      ))}
    </div>
  );
};

const EmailList = ({ emails, newEmail, setNewEmail, loading, selectedPlant, onAddEmail, onRemoveEmail }) => (
  <div className="bg-white rounded-lg shadow-md p-4 sm:p-6">
    <div className="flex items-center justify-between mb-4 sm:mb-6">
      <div className="min-w-0">
        <h2 className="text-xl sm:text-2xl font-bold text-gray-900">Notification Emails</h2>
        <p className="text-sm text-gray-600 mt-1 break-words">
          Manage email recipients for daily reports for <strong>{selectedPlant?.name}</strong>
        </p>
      </div>
    </div>

    <div className="flex flex-col sm:flex-row gap-2 sm:gap-3 mb-4 sm:mb-6">
      <input
        type="email"
        inputMode="email"
        value={newEmail}
        onChange={(e) => setNewEmail(e.target.value)}
        className="flex-1 px-4 py-2.5 min-h-[44px] border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#156ACA] text-base"
        placeholder="Enter email address"
        data-testid="add-email-input"
      />
      <button
        onClick={onAddEmail}
        disabled={loading}
        className="bg-[#156ACA] hover:bg-[#0F5299] text-white font-semibold py-2.5 px-6 min-h-[44px] rounded-lg transition-colors disabled:opacity-50 flex items-center justify-center"
        data-testid="add-email-btn"
      >
        <Plus className="h-5 w-5 mr-2" />
        Add Email
      </button>
    </div>

    {renderEmailList(loading, emails, onRemoveEmail)}

    <div className="mt-6 p-4 bg-blue-50 rounded-lg border border-blue-200">
      <p className="text-sm text-blue-800">
        <strong>Note:</strong> These email addresses will receive daily production reports for <strong>{selectedPlant?.name}</strong>.
        Each plant can have its own email list.
      </p>
    </div>
  </div>
);

export default EmailList;
